import React from "react";
import "./Loading.css";

function Loading() {
  return (
    <div className="Loading">
      <div className="spinner"></div>
    </div>
  );
}

export default Loading;
